import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import AIAssistant from '../components/AIAssistant';
import Layout from '../components/layout/Layout';

const AIAssistantPage: React.FC = () => {
  return (
    <Layout>
      <Container maxWidth="lg">
        <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            AI Tax Assistant
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" paragraph>
            Ask any tax-related questions and get instant answers powered by AI.
          </Typography>
          
          <AIAssistant />
        </Box>
      </Container>
    </Layout>
  );
};

export default AIAssistantPage; 